import { css } from '@emotion/css';
import routeActiveBg from 'assets/images/bg/title-register.jpg';
import { colors } from 'constants/theme';

const fundTransferStyle = {
    viewTotalMoney: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        background-color: #b2c6c7;
        font-size: 20px;
        font-family: 'UTM AvoBold', sans-serif;
        p {
            display: inline-block;
            max-width: 100%;
            font-weight: 700;
        }
    `,
    wrap: css`
        display: flex;
        flex-direction: column;
        gap: 50px;
        color: black;
    `,
    left: css`
        /* flex: 0 0 400px; */
        display: flex;
        align-items: center;
        gap: 20px;
    `,
    groupInput: css`
        flex: 1;
        /* padding-bottom: 20px; */
        position: relative;
        label {
            display: block;
            margin-bottom: 4px;
            padding-left: 2px;
            font-weight: bold;
            color: ${colors.primary};
            font-size: 16px;
        }
        input {
            width: 100%;
        }
        .wrapInput {
            position: relative;
            height: 40px;
            input {
                height: 100%;
                padding: 0 12px;
            }
        }
        .inputCommon {
            background: transparent;
            padding: 8px 12px;
            color: ${colors.black};
            width: 100%;
            height: 100%;
            outline: none;
            border: 0;
            border-bottom: 1px solid #000;
            font-size: 14px;
            &::placeholder {
                font-size: 14px;
                color: black;
                letter-spacing: 0;
            }
        }

        .chooseAmount {
            display: flex;
            gap: 10px;
            margin-top: 10px;
            padding-left: 20px;
            .itemChoose {
                padding-left: 10px;
                padding-right: 10px;
                padding-top: 5px;
                padding-bottom: 5px;
                background-color: #efefef;
                font-weight: 300;
                font-size: 12px;
                color: black;
                cursor: pointer;
                &:hover {
                    background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
                    color: white;
                }
            }
        }
    `,
    wrapInput: css`
        /* padding: 0 8px;
        border: 0;
        border-bottom: 1px solid #000;
        border-radius: 0; */
    `,
    inputCommon: css`
        padding: 8px 8px;
        border: 0;
        border-bottom: 1px solid #000;
        border-radius: 0;
        outline: none;
    `,
    right: css`
        flex: 1;
    `,
    balanceMain: css`
        display: flex;
        gap: 40px;
        background: url(${routeActiveBg}) no-repeat;
        background-size: cover;
        padding: 10px 12px;
        border-radius: 8px;
        border: 1px solid ${colors.borderPrimary};
        p {
            flex: 1;
        }
        span {
            &:last-child {
                color: ${colors.yellow};
                margin-left: 4px;
            }
        }
    `,
    gameWrap: css`
        /* padding: 20px 16px; */
        /* border: 1px solid ${colors.borderPrimary}; */
        /* border-radius: 8px; */
        /* margin-top: 12px; */
        /* background: ${colors['gradient-popup']}; */
    `,
    gameGroup: css`
        margin-bottom: 12px;
        &:last-child {
            margin-bottom: 0;
        }
    `,
    gameList: css`
        display: flex;
        flex-wrap: wrap;
        margin: 0 -4px;
    `,
    gameGroupTitle: css`
        margin-bottom: 4px;
        font-weight: 400;
    `,
    gameItem: css`
        padding: 4px;
        flex: 0 0 calc(100% / 3);
        max-width: calc(100% / 3);
    `,
    transferNotice: css`
        font-size: 14px;
        padding-left: 12px;
        .titleRef {
            color: #d90500;
        }

        span {
            font-weight: bold;
            font-size: 13px;
        }
        p {
            font-weight: bold;
            font-size: 13px;
        }
    `,
    tabTransfer: css`
        display: flex;
        gap: 8px;
        margin-top: 24px;
        .tab-item {
            padding: 4px 8px;
            cursor: pointer;
            background: ${colors.blackText};
            border-radius: 4px;
            font-size: 15px;
            border: 1px solid ${colors.primary};
            &.active {
                background: ${colors.primary};
            }
        }
    `,
    btnConfirm: css`
        border: 1px solid #c9820a !important;
        border-radius: 3px !important;
        color: #fff !important;
        background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
        padding-left: 15px;
        padding-right: 15px;
        align-self: flex-end;
        height: 45px;
    `,
};
export default fundTransferStyle;
